const QuestionId = {
  DriverRating: 'vuxx-entregador',
  Comment: 'comentarios',
};

export default QuestionId;
